<template>
  <ZigzagServiceLayout
    mainTitle="IM/IV & Vitamin Therapies"
    mainDescription="Energy, Balance, and Wellness from the Inside Out. Our medically supervised IV therapies deliver hydration, nutrients, and antioxidants directly into your system for faster absorption and lasting benefits."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'IMIVVitaminTherapiesContentEn',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'HYDRATION & RECOVERY',
          title: 'Wellness & Full-Body Hydration',
          subtitle: 'Restore balance with electrolytes, vitamins, and antioxidants.',
          paragraphs: [
            "Our hydration IV therapies are designed to quickly replenish your body's essential fluids and nutrients.",
            "Whether you need a Recovery IV to rehydrate and rebalance after fatigue, travel, or stressful days, our supervised infusions deliver immediate relief and lasting wellness."
          ],
          list: [
            "Complete body hydration with electrolytes",
            "Antioxidant support for immune health",
            "Rapid recovery for fatigue and stress",
            "Alleviation of travel and jet lag symptoms"
          ],
          image: '/images/services/iv-hydration.png'
        },
        {
          label: 'PERFORMANCE',
          title: 'Energy, Metabolism & Weight Support',
          subtitle: 'Boost energy and post-workout recovery.',
          paragraphs: [
            "Tailored infusions loaded with B12, essential amino acids, and B vitamins help optimize your energy levels and metabolic function.",
            "These therapies are ideal for supporting safe, supervised weight management and accelerating recovery after intense physical activity."
          ],
          list: [
            "B12 and amino acids for natural energy boosts",
            "Enhanced metabolism and weight management support",
            "Faster post-workout muscle recovery",
            "Improved focus and vitality"
          ],
          image: '/images/services/iv-energy.png'
        },
        {
          label: 'AESTHETICS',
          title: 'Skin Health & Rejuvenation',
          subtitle: 'Support your skin, hair, and natural glow.',
          paragraphs: [
            "Nourish your beauty from within. Our specialized vitamin blends support healthy hair and glowing skin by delivering high doses of essential nutrients directly to your cells.",
            "These rejuvenating drips are completely safe and formulated to enhance your natural radiance and combat the signs of aging."
          ],
          list: [
            "Vitamin blends for a radiant, natural glow",
            "Support for healthy hair and nail growth",
            "Anti-aging antioxidant protection",
            "Hydration for plump, youthful skin"
          ],
          image: '/images/services/iv-beauty.png'
        }
      ]
    };
  }
};
</script>
